import './Navbar.css'
export default function Navbar(){
    return (
        <nav className="navbar">
            <div className="logo">
                <h2>The Wild West World Bunch</h2>
                <span>by Bug Busters</span>
            </div>
            <ul className="nav-links">
                <li><a href="/">Home</a></li>
                <li><a href="/game">Play</a></li>
                <li><a href="/TheWildBunch">The Wild Bunch</a></li>
                <li><a href="/high-scores">High Scores</a></li>
            </ul>
        </nav>
    );
}